export default __webpack_public_path__ + "static/media/acms-division.36802d02.svg";